import { Company } from "@finway-group/shared/lib/models"
import { Col, Row, Switch } from "antd"
import Form, { FormInstance } from "antd/lib/form"
import { Store } from "antd/lib/form/interface"
import React, { useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { useLoggedInEmployee } from "~Shared/hooks/employee.hooks"

interface ExportAndBookkeepingFormProps {
    formInstance: FormInstance
    onSubmit: (values: Store) => void
    company: Company
}

export const ExportAndBookkeepingForm = ({ formInstance, onSubmit, company }: ExportAndBookkeepingFormProps) => {
    const { t } = useTranslation()
    const loggedInUser = useLoggedInEmployee()

    useEffect(() => {
        if (company) {
            formInstance.setFieldsValue({
                ...company,
            })
        }

        return () => {
            formInstance.resetFields()
        }
    }, [])

    const onFinish = (values: Store) => onSubmit({ ...values })

    return (
        <Form form={formInstance} layout="vertical" onFinish={onFinish} autoComplete="off">
            <Row gutter={[16, 16]}>
                <Col span={8}>
                    <Form.Item label={t("input:company_settings.is_lexware_export_enabled")} name="isLexwareExportEnabled" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Form.Item label={t("input:company_settings.add_audit_trail_to_invoice_export")} name="isAppendAuditTrailToInvoiceEnabled" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </Col>
                {loggedInUser.email === PROCESS_ENV.FINWAY_ADMIN_EMAIL ? (
                    <Col span={8}>
                        <Form.Item label={t("input:company_settings.is_non_sepa_xml_export_enabled")} name="isNonSepaXmlExportEnabled" valuePropName="checked">
                            <Switch disabled={loggedInUser.email !== PROCESS_ENV.FINWAY_ADMIN_EMAIL} />
                        </Form.Item>
                    </Col>
                ) : null}
                <Col span={8}>
                    <Form.Item
                        label={t("input:company_settings.enforce_belegfunktion")}
                        name={["gobdCompliance", "enforceGobdCompliantInvoice"]}
                        valuePropName="checked"
                        extra={
                            <Trans
                                t={t}
                                i18nKey="info:gobd_compliance.ask_support_to_enable"
                                components={[<a key="1" href={t("info:gobd_compliance.link")} target="_blank" rel="noreferrer" className="text-blue underline" />]}
                            />
                        }
                    >
                        <Switch disabled={loggedInUser.email !== PROCESS_ENV.FINWAY_ADMIN_EMAIL} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}
